import axios from 'axios'
import store from '../store'

export default {
    methods: {
        _rpc_base(mod, view, func, args, msg, context, options, success, failure) {
            let _context = Object.assign({}, store.state.context)
            if(context !== undefined) {
                Object.assign(_context, context)
            }
            let body = {
                args: args,
                context: _context
            }

            if(msg !== "__bg__") {
                store.commit('setLoading', {show: true, msg: msg})
            }
            let url = "/rest/" + mod + "/" + view + "/" + func
            console.log('rpc(' + url + ', ' + JSON.stringify(body) + ')')
            return new Promise(
                function (resolve, reject) {
                    axios.post(url, JSON.stringify(body), options)
                        .then((response) => {
                            store.commit('setLoading', {show: false})
			    resolve(response)
                        })
                        .catch((error) => {
                            store.commit('setLoading', {show: false})
                            if(error.result === "Not Logged In") {
                                store.commit('setInitState', 'notLoggedIn')
                            }
			    reject(error)
                        })
                })
        },
        rpc_download(mod, view, func, args, msg, context) {
	    var self=this
	    return new Promise(
		function (resolve, reject) {
		    self._rpc_base(mod, view, func, args, msg, context, {
			responseType: 'arraybuffer',
			timeout: 600000,
		    })
			.then(function(response) {
			    console.log("response", response)
			    if(response.data.status === "ERROR") {
				reject(response.data)
				return
			    }
			    var filename = response.headers.filename
			    console.log(filename);
			    const url = window.URL.createObjectURL(new Blob([response.data]));
			    const link = document.createElement('a');
			    link.href = url;
			    link.setAttribute('download', filename);
			    document.body.appendChild(link);
			    link.click();
			    //document.body.removeChild(link);
			})
			.catch(function(error) {
			    console.log(' ERROR')
			    console.log(error)
			    reject({result: error.message})
			})
		})
        },
        rpc(mod, view, func, args, msg, context) {
	    var self=this
	    return new Promise(
		function (resolve, reject) {
		    self._rpc_base(mod, view, func, args, msg, context, {})
			.then(function(response) {
			    console.log(' RESPONSE')
			    console.log(response)
			    if (response.data.status === 'OK') {
				console.log("  RESOLVE")
				resolve(response.data.result)
			    } else if(response.data.result === "'AnonymousUser' object is not iterable") {
				console.log("  LOGGED OUT")
				store.commit('setInitState', 'created')
				store.commit('setUser', null)
			    } else {
				console.log("  REJECT")
				reject(response.data)
			    }
			})
			.catch(function(error) {
			    console.log(' ERROR')
			    console.log(error)
			    reject({result: error.message})
			})
		}
	    )
        }
    }
}
